/**
 * 年度回款金额数量统计组件
 */

import { useEffect, useState } from 'react';
import { message } from 'antd';
import { Chart } from '@antv/g2';
import $ from 'jquery';
import { AddRequestHeaders, } from '../../incs/FunHelper.js';
import CNF from '../../incs/Config.js';

const ProjectDRAY = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [isRefresh, setIsRefresh] = useState(true);
    const [data, setData] = useState([]);

    useEffect(() => {
        if (props.data) {
            setData(props.data);
        } else {
            if (isRefresh) {
                // 获取数据
                $.ajax({
                    url: `${CNF.api}reports/project/dray`,
                    headers: AddRequestHeaders(),
                    crossDomain: true,
                    type: 'GET',
                    dataType: 'JSON', success: function (data) {
                        if (data.res === 0) {
                            setData(data.dat);
                            setIsRefresh(false);
                        } else {
                            messageApi.error(data.msg, CNF.messageDuration);
                        }
                    }
                })
            }
        }
    }, [props, isRefresh, messageApi]);

    useEffect(() => {
        const chart = new Chart({
            container: 'antv-g2-id',
            autoFit: true,
        });

        chart.title({
            title: '年度回款金额走势',
            subtitle: '展示年度内回款金额数量统计走势。',
        });

        chart.data(data);

        chart
            .interval()
            .encode('x', 'year')
            .encode('y', 'amount')
            .axis('x', { title: '年份', })
            .axis('y', {
                title: '金额',
                // titleFill: CNF.swatches[CNF.currentSwatche][0],
                labelFormatter: (d) => `${d > 10000 ? (d / 10000).toFixed(2) + '万元' : d + '元'}`,
            })
            .animate('enter', {
                type: 'scaleInY',
                duration: CNF.animateDuration,
            },)
            .style('minWidth', 40)
            .style('maxWidth', 60)
            .tooltip({
                items: [(d => ({
                    name: '合同金额',
                    value: `${d.amount > 10000 ? (d.amount / 10000).toFixed(2) + '万元' : d.amount + '元'}`,
                }))],
            });

        chart
            .line()
            .encode('x', 'year')
            .encode('y', 'count')
            .encode('shape', 'smooth')
            .style('stroke', CNF.swatches[CNF.currentSwatche][2],)
            .style('lineWidth', 2)
            .scale('y', { independent: true })
            .axis('y', {
                position: 'right',
                grid: null,
                title: '笔数',
                // titleFill: CNF.swatches[CNF.currentSwatche][2],
            }).tooltip({
                items: [(d => ({
                    name: '回款笔数',
                    value: `${d.count}笔`,
                }))],
            })
            .animate('enter', {
                type: 'pathIn',
                duration: CNF.animateDuration,
            },);

        chart.render();

        return () => {
            chart.destroy();
        }
    }, [props.collapsed, data]);

    return <>
        {contextHolder}
        <div id='antv-g2-id'></div>
    </>

}

export default ProjectDRAY;